import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from "../firebase";
import { doc, getDoc, getDocs, collection } from "firebase/firestore";
import Globals from '../Globals';
import NavBar from '../Components/NavBar';
import Container from 'react-bootstrap/Container';
import Accordion from 'react-bootstrap/Accordion';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';
import SplitButton from 'react-bootstrap/SplitButton';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Tooltip from 'react-bootstrap/Tooltip';

const TeamStats = () => {

    const { teamName } = useParams();
    // const [players, setPlayers] = useState({});
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState('oneTableRadio');
    const [activeFilters, setActiveFilters] = useState(() => new Set());
    const [sortBy, setSortBy] = useState('name');
    const [sortAsc, setSortAsc] = useState(true);
    const [seasonInfo, setSeasonInfo] = useState([]);
    const [seasonYears, setSeasonYears] = useState([]);
    // const [showToolTip, setShowToolTip] = useState('');
    /*
    Season year
    Game #
    Team name
    Win/Loss
    Our Score
    Their Score
    Playoff Game
    Practice Game
    Lineup?
    */

    const viewOptions = [
        {
            id: 'oneTableRadio',
            label: "One Table",
            nameField: 'oneTable',
        },
        {
            id: 'multiTableRadio',
            label: "Multiple Tables",
            nameField: 'multiTable',
        },
    ]

    /*
    wins
    Regular
    Playoffs
    Practice
    2025
    2024
    ...
    2020
    */
    const filterOptions = [
        {
            id: 'winsCheckbox',
            label: "Wins",
            nameField: "victory",
            compareTo: "isSub",
            filterIfZero: true
        },
        {
            id: 'regularSeason',
            label: 'Regular Season',
            nameField: 'regularSeason',
            compareTo: 'isPlayoff && isPractice',
            filterIfZero: false,
        },
        {
            id:'playOffCheckbox',
            label:"Playoff Games",
            nameField:"playoffGames",
            compareTo: "isPlayoff",
            filterIfZero: false
        },
        {
            id:'practiceCheckbox',
            label:"Practice Games",
            nameField:"practiceGames",
            compareTo: "isSub",
            filterIfZero: false
        }
    ];

    seasonYears?.forEach(year => filterOptions.push({
        id: `game${year}`,
        label: year,
        nameField: `game${year}`,
    }));

    const sortOptions = [
        {
            id: 'gameNumberRadio',
            label: "Game Number",
            stat:'id'
        },
        {
            id: 'teamNameRadio',
            label: "Opponent",
            stat:'them'
        },
        {
            id: 'ourScoreRadio',
            label: "Our Score",
            stat:'ourScore'
        },
        {
            id: 'theirScoreRadio',
            label: "Their Score",
            stat:'theirScore'
        },
    ];

    function showSortSVG(sortAsc){
        return (sortAsc ? 
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-sort-alpha-down" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z"/>
                <path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
            </svg>
            :
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-sort-alpha-up-alt" viewBox="0 0 16 16">
                <path d="M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645z"/>
                <path fillRule="evenodd" d="M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371zm1.57-.785L11 9.688h-.047l-.652 2.156z"/>
                <path d="M4.5 13.5a.5.5 0 0 1-1 0V3.707L2.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.5.5 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L4.5 3.707z"/>
            </svg>
        )
    }


    const SeasonsInfo = ({games, gameType, year}) => {(
        <Accordion defaultActiveKey={"Regular"} key={'outsideAccordion'}>
            <Accordion.Item eventKey={year & "_" & gameType} key={'insideAccordion'}>
                <Accordion.Header>{year} - {gameType}</Accordion.Header>
                <Accordion.Body>
                    <ListGroup>
                    {games.map((oneGame, idx) => {
                        return (
                            <ListGroup.Item>
                                <Container>
                                    <Row>
                                        <Col></Col>
                                    </Row>
                                </Container>
                            </ListGroup.Item>
                        )
                    })}
                    </ListGroup>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )}
    
    useEffect(() => {
        const func = async () => {
            const docRef = doc(db, "teams", teamName,);
            const userCartsCollectionRef = collection(db, 'teams', teamName, 'allSeasons');
            Promise.all([getDoc(docRef), getDocs(userCartsCollectionRef)])
            .then(evaluatedPromise => {
                const docSnap = evaluatedPromise[0];
                console.log('docSnap.data() :', docSnap.data());
                const querySnapshot = evaluatedPromise[1]
                setLoading(false);
                const tempSeasonInfo = [];
                const tempSeasonYears = [];
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    // console.log(doc.id, " => ", doc.data());
                    tempSeasonYears.push(doc.id);
                    tempSeasonInfo.push(doc.data().games);
                  });

                setSeasonInfo(tempSeasonInfo);
                setSeasonYears(tempSeasonYears);
                // setPlayers(docSnap.data().players.sort());

            });

        }

        func();
    }, [teamName]);
    
    return (
        <>
            <NavBar teamName={teamName}/>
            <Container className='mx-0'>
                {loading
                    ? (<Row><Col><h1 className="loading">Loading Team Stats...</h1></Col></Row>) 
                    : (
                    <>
                    <Row className='mb-2'>
                        <Col>
                            <ButtonGroup className='my-1 w-100'>
                                <DropdownButton as={ButtonGroup} id='dropdown-views' variant='primary' title='Views' className='w-100 whiteBorder' autoClose='outside'>
                                    <Form className='ps-2'>
                                        {viewOptions.map((element, idx) =>
                                            <Form.Check
                                                label={element.label}
                                                name={element.id}
                                                type={'radio'}
                                                id={element.id}
                                                checked={element.id === view}
                                                key={element.id.replace(" ", "_") + idx}
                                                onChange={() => setView(element.id)}
                                            />
                                        )}
                                    </Form>
                                </DropdownButton>
                                <DropdownButton as={ButtonGroup} id='dropdown-filters' variant='primary' title='Filters' className='w-100 whiteBorder' autoClose='outside'>
                                    <Form className='ps-2'>
                                        {filterOptions.map((element, idx) =>
                                            <Form.Check
                                                label={element.label}
                                                name={element.id}
                                                type={'checkbox'}
                                                id={element.id}
                                                checked={activeFilters.has(element.id)}
                                                key={element.id.replace(" ", "_") + idx}
                                                onChange={ e => e.currentTarget.checked ? Globals.addItem(element.id, setActiveFilters) : Globals.removeItem(element.id, setActiveFilters) }
                                            />
                                        )}
                                    </Form>
                                </DropdownButton>
                                <SplitButton
                                    id={'sortDirection'}
                                    title={showSortSVG(sortAsc)}
                                    as={ButtonGroup} 
                                    variant={'primary'} 
                                    className='w-100 whiteBorder directChild'
                                    autoClose='outside'
                                    onClick={() => setSortAsc((prev => !prev))}
                                >
                                    <Form className='ps-2'>
                                        {sortOptions.map((element, idx) =>
                                            <Form.Check
                                                label={element.label}
                                                name={element.id}
                                                type={'radio'}
                                                id={element.id}
                                                checked={element.stat === sortBy}
                                                key={element.id.replace(" ", "_") + idx}
                                                className='whiteBorder'
                                                onChange={() => setSortBy(element.stat)}
                                            />
                                        )}
                                    </Form>
                                </SplitButton>
                            </ButtonGroup>
                        </Col>
                    </Row>
                    <Row><Col>
                    {seasonYears.map((oneYear, index) => {
                        const yearHasPlayOffGames = seasonInfo[index].filter(oneGame => oneGame.isPlayoffs);
                        const yearHasPracticeGames = seasonInfo[index].filter(oneGame => oneGame.isPractice);
                        const yearHasRegularGames = seasonInfo[index].filter(oneGame => !oneGame.isPractice && !oneGame.isPlayoffs);
                        return (
                            <>
                                <SeasonsInfo games={yearHasPracticeGames} gameType="Practice" year={oneYear}/>
                                <SeasonsInfo games={yearHasRegularGames} gameType="Regular" year={oneYear}/>
                                <SeasonsInfo games={yearHasPlayOffGames} gameType="Playoffs" year={oneYear}/>
                            </>
                        );
                    })}
                    </Col></Row>
                    </>
                )}
            </Container>
        </>
    );
};

export default TeamStats;
